export const MAX_VECTOR_STORE_NAVN = 255;
export const MAX_VECTOR_STORE_BESKRIVELSE = 1000;

export const VECTOR_STORE_ALLOWED_EXTENSIONS = ['.md', '.txt', '.pdf', '.docx', '.json'] as const;

export const VECTOR_STORE_ACCEPT_ATTR = VECTOR_STORE_ALLOWED_EXTENSIONS.join(',');
